module.exports = __webpack_public_path__ + "static/media/maf-53.0da7f839.png";